'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryVehiclesController = function () {
  function EnquiryVehiclesController(authService, enums, $state, printService, $ngConfirm, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquiryVehiclesController);
    this.authService = authService;
    this.enums = enums;
    this.$state = $state;
    this.printService = printService;
    this.$ngConfirm = $ngConfirm;
    this.$scope = $scope;

    this.total = 0;

    this.$scope.$on('enquiry:initialized', this.getTotal.bind(this));
  }

  (0, _createClass3.default)(EnquiryVehiclesController, [{
    key: 'vehicleSelected',
    value: function vehicleSelected(vehicleId) {
      var enquiryVehicles = void 0;

      enquiryVehicles = (0, _lodash.filter)(this.enquiry.enquiryVehicles, function (o) {
        return o.vehicleId !== vehicleId;
      });

      enquiryVehicles.map(function (ev) {
        ev.isSelected = false;
      });

      this.onVehicleSelected();
    }
  }, {
    key: 'quotation',
    value: function quotation() {
      if (this.enquiry.enquiryVehicles.length) {
        var vehicle = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
          return o.isSelected;
        }).vehicle;

        if (!vehicle.price || vehicle.price === 0) {
          this.$ngConfirm({
            title: 'ERROR',
            content: 'Selected vehicle does not have a retail price',
            type: 'red',
            typeAnimation: false,
            columnClass: 'm',
            buttons: {
              tryAgain: {
                text: 'Close',
                btnClass: 'btn-danger'
              }
            }
          });
        } else {
          this.printService.printQuotation(this.enquiry.enquiryId);
        }
      }
    }
  }, {
    key: 'gotoVehicle',
    value: function gotoVehicle(v) {
      this.editVehicle = v;
      this.$state.go('vehicleEdit', {
        vehicleId: v.vehicle.vehicleId,
        origin: {
          source: 'enquiryEdit',
          processResult: this.getReturnParams.bind(this)
        }
      });
    }
  }, {
    key: 'getReturnParams',
    value: function getReturnParams(vehicleId, vehicle) {
      var ctrl = this;
      var stateName = 'enquiryEdit';

      this.editVehicle.vehicle.price = vehicle.price;

      /*
      * #1310
      * Update entityid of vehicle, if a vehicle was attached
      * in case, the location of the vehicle was changed
      */
      var ev = (0, _lodash.find)(this.enquiry.enquiryVehicles, function (o) {
        return o.isSelected;
      });
      if (ev) {
        ev.vehicle.entityId = vehicle.entityId;
      }

      var params = {
        activeTab: 'vehicles',
        enquiryId: ctrl.enquiry.enquiryId,
        enquiry: ctrl.enquiry
      };

      var vehiclePrice = (0, _lodash.find)(params.enquiry.enquiryPrices, function (o) {
        return o.name === 'Vehicle Price';
      });
      if (vehiclePrice) {
        vehiclePrice.amount = vehicle.price;
      }

      return {
        stateName: stateName,
        params: params
      };
    }
  }, {
    key: 'selectVehicle',
    value: function selectVehicle() {
      if (!this.enquiry.enquiryOrigination) {
        this.formValidationService.addSystemError(null, 'Please specify Enquiry Origination first', false);
        return;
      }

      this.$state.go('vehicleEnquiryView', { source: 'enquiry', enquiry: this.enquiry });
    }
  }, {
    key: 'removeEnquiryVehicleConfirm',
    value: function removeEnquiryVehicleConfirm(v) {
      var _this = this;

      this.$ngConfirm({
        title: 'Remove Vehicle',
        content: 'Are you sure youn want to remove this vehicle ?',
        type: 'red',
        typeAnimation: false,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Yes',
            btnClass: 'btn-danger',
            action: function action() {
              return _this.removeEnquiryVehicle(v);
            }
          },
          no: {
            text: 'no',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'removeEnquiryVehicle',
    value: function removeEnquiryVehicle(vehicle) {
      if (this.enquiry.isMultiSelect) {
        this.enquiry.enquiryVehicles = (0, _lodash.without)(this.enquiry.enquiryVehicles, vehicle);
      } else {
        vehicle.isRemoved = true;
      }

      this.getTotal();
      this.$scope.$apply();
    }
  }, {
    key: 'getTotal',
    value: function getTotal() {
      this.total = (0, _lodash.sum)(this.enquiry.enquiryVehicles.map(function (ev) {
        return ev.vehicle.price || 0;
      }));
    }
  }]);
  return EnquiryVehiclesController;
}();

exports.default = EnquiryVehiclesController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryVehicles/enquiryVehicles.controller.js